import { Form } from 'antd';
import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { MasterStationsWithSearchKeys } from 'domain/entities/MasterEntity';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { commonHelpers } from 'utilities/helpers';
import styles from '../styles.module.scss';
import { OptionalFieldsSection } from './OptionalFieldsSection';
import { RequiredFieldsSection } from './RequiredFieldsSection';
import { SubmitButton } from './SubmitButton';

export const EvaluateForm = (props: AppProps) => {
    const [isDisableRepairFund, setIsDisableRepairFund] = useState(true);
    const [btnDisable, setBtnDisable] = useState(true);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { masterUseCase, assessmentUseCase } = props;
    const [allStation, setAllStation] = React.useState<OptionEntity[]>([]);
    const [stationSelect, setStationSelect] = React.useState<any>();

    useEffect(() => {
        getStationByKeys('');
    }, []);

    useEffect(() => {
        if (isDisableRepairFund) {
            form.setFieldsValue({ repair_fund: undefined });
        }
    }, [isDisableRepairFund]);

    const getStationByKeys = async (key: string) => {
        try {
            dispatch(startFetching());
            const response = await masterUseCase.getMasterStationByKeys(key);
            const stationOption = response.result?.map((item: MasterStationsWithSearchKeys) => ({
                value: item.stationCd,
                label: item.stationName,
                code: item.stationCd,
            }));
            setAllStation(
                stationOption.filter(
                    (item: OptionEntity, pos: number, self: OptionEntity[]) =>
                        self.indexOf(item) === pos,
                ),
            );
        } catch {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeForm = () => {
        form.validateFields({ validateOnly: true })
            .then((values) => {
                setBtnDisable(!(values.age_building || values.rent_price));
            })
            .catch((err) => {
                if (err.errorFields.length === 0) {
                    const { values } = err;
                    setBtnDisable(!(values.age_building || values.rent_price));
                } else {
                    setBtnDisable(true);
                }
            });
    };

    const onSubmitForm = async (values: any) => {
        try {
            dispatch(startFetching());
            const stationName = allStation?.find((val) => val.value === values.station)?.label;
            const assessmentSimple: AssessmentSimple = {
                ...values,
                area: commonHelpers.toNumberOnly(values.area),
                rent_price: commonHelpers.toNumberOnly(values.rent_price),
                repair_fund: commonHelpers.toNumberOnly(values.repair_fund),
                station_cd: stationSelect?.code,
                stationName,
            };
            const response = await assessmentUseCase.putAssessmentSimpleData(assessmentSimple);
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_03}`, {
                state: {
                    assessmentData: assessmentSimple,
                    range: response.result,
                    stationSelect,
                },
            });
        } catch {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const handleStationSelect = (option: OptionEntity | undefined) => {
        setStationSelect(option);
        form.setFieldValue('station_cd', option?.label);
    };

    const handleStationBlur = (option: OptionEntity | undefined) => {
        if (option) {
            setStationSelect(option);
            form.setFieldsValue({ station_cd: option.label });
        } else {
            setStationSelect(undefined);
            form.setFieldsValue({ station_cd: null });
            form.validateFields(['station_cd'], { validateOnly: false })
                .then(() => onChangeForm())
                .catch((err) => {
                    if (err.errorFields.length > 0) {
                        setBtnDisable(true);
                    } else {
                        onChangeForm();
                    }
                });
        }
    };

    return (
        <Form
            form={form}
            onValuesChange={onChangeForm}
            onFinish={onSubmitForm}
            className={styles.form}
        >
            <RequiredFieldsSection
                allStation={allStation}
                onStationSelect={handleStationSelect}
                onStationBlur={handleStationBlur}
            />

            <OptionalFieldsSection
                isDisableRepairFund={isDisableRepairFund}
                onRentChange={(value) => setIsDisableRepairFund(!value)}
            />

            <SubmitButton
                label="査定結果を見る"
                disabled={btnDisable}
                onClick={() => !btnDisable && form.submit()}
            />
        </Form>
    );
};
